import React from "react";
import { Link } from "react-router-dom";

const LOGO_SRC = "/brand/petbond-logo.png";

/**
 * BrandLogo - PetBond official mark
 * variant: "full" (logo + wordmark + tagline) | "wordmark" (just text) | "icon" (just badge)
 * size: "sm" | "md" | "lg" | "xl"
 */
export default function BrandLogo({ variant = "wordmark", size = "md", to = "/", className = "", tagline = false }) {
  const sizes = {
    sm: { img: "h-7 w-7", text: "text-lg" },
    md: { img: "h-9 w-9", text: "text-2xl" },
    lg: { img: "h-14 w-14", text: "text-3xl" },
    xl: { img: "h-24 w-24", text: "text-5xl" },
  };
  const s = sizes[size] || sizes.md;

  const inner = (
    <>
      <img src={LOGO_SRC} alt="PetBond" className={`${s.img} object-contain shrink-0`} />
      {variant !== "icon" && (
        <div className="flex flex-col leading-none">
          <span className={`font-heading ${s.text} font-extrabold tracking-tight`}>
            <span className="text-brand">Pet</span><span className="text-brand-blue">Bond</span>
          </span>
          {tagline && (
            <span className="text-[10px] sm:text-xs font-bold tracking-widest mt-0.5 uppercase">
              <span className="text-brand-blue">Meet.</span>{" "}
              <span className="text-brand">Care.</span>{" "}
              <span className="text-brand-blue">Adopt.</span>{" "}
              <span className="text-brand-green">Shop.</span>
            </span>
          )}
        </div>
      )}
    </>
  );

  if (to) return <Link to={to} className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">{inner}</Link>;
  return <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">{inner}</div>;
}
